<template>
  <span class="text-gray-500 dark:text-gray-500">
    ---
  </span>
</template>
